import { Injectable } from "@angular/core";
import { Observable, map, timeout } from "rxjs";
import { BBResponseContainer } from "../carrier/response-container";
import { environment } from './../../environments/environment';
import { HttpClient } from "@angular/common/http";
import { Plate } from "../models-new/plate";
import { Sample } from "../models-new/sample";
import { MultiPlateUpdate } from "../ma-plate-preparation/multiplate-update-dto";

@Injectable({
    providedIn: 'root'
})
export class ReceptionNewService {

    readonly PLATE_PREPARATION_API = environment.BB_SAMPLE_PROCESSING_API
    readonly SAMPLE_UPDATE_API = environment.BB_MA_DELIVERY_API

    constructor(private httpClient: HttpClient) { }
    
    createPlate(plate: Plate): Observable<Plate> {
        let url = this.PLATE_PREPARATION_API + 'plate';
        return this.httpClient.post<BBResponseContainer>(url, plate).pipe((map(response => response.data as Plate))).pipe(timeout(environment.defaultTimeout));
    }

    fetchPlates(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date, selectedSampleType?: any): Observable<Plate[]> {
        let url = this.PLATE_PREPARATION_API + 'plate?labid=' + labId;
        if (typeof type !== 'undefined') {
            url = url + '&type=' + type;
        }
        if (typeof status !== 'undefined') {
            url = url + '&status=' + status;
        }
        if (typeof processFlowName !== 'undefined') {
            url = url + '&processFlowName=' + processFlowName;
        }
        if (fromDate !== undefined && fromDate !== null) {
            url = url + '&fromDate=' + fromDate.toDateString();
        }
        if (typeof selectedSampleType !== 'undefined') {
            url = `${url}&selectedSampleType=${selectedSampleType}`;
        }
        return this.httpClient.get<BBResponseContainer>(url).pipe((map(response => response.data as Plate[]))).pipe(timeout(environment.defaultTimeout));
    }

    updatePlate(plateID: string, plate: Plate, labId: string, lastUpdatedStep: string = ""): Observable<Plate> {
        let url = this.PLATE_PREPARATION_API + 'plate/' + labId + "/" + plateID;
        if (lastUpdatedStep !== "") {
            url = `${url}?lastUpdatedStep=${lastUpdatedStep}`
        }
        return this.httpClient.put<BBResponseContainer>(url, plate).pipe((map(response => response.data as Plate))).pipe(timeout(environment.defaultTimeout));
    }

    commentDetailsbyPlateId(labId: string, plateId: string) {
        let url = this.PLATE_PREPARATION_API + 'commentDetailsbyPlateId/' + labId + "/" + plateId;
        return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as Plate))).pipe(timeout(environment.defaultTimeout));
    }

    fetchPlate(plateID: string, labId: string) {
        let url = this.PLATE_PREPARATION_API + 'plate/' + labId + "/" + plateID;
        return this.httpClient.get<BBResponseContainer>(url).pipe((map(response => response.data as Plate))).pipe(timeout(environment.defaultTimeout));
    }

    checkSamplePresentInPlate(labId: string, sampleid: string) {
        let url = this.PLATE_PREPARATION_API + 'checkSamplePresent/' + labId + "/" + sampleid;
        return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data)).pipe(timeout(environment.defaultTimeout));
    }

    addSampleToPlate(labId: string, plateId: string, sample: Sample) {
        let url = this.PLATE_PREPARATION_API + 'addSampleToPlate/' + labId + '/' + plateId;
        return this.httpClient.put<BBResponseContainer>(url, sample).pipe((map(response => response.data as Plate))).pipe(timeout(environment.defaultTimeout));
    }

    removeSamples(body) {
        let url = this.PLATE_PREPARATION_API + "removeSample";
        return this.httpClient.post<any>(url, body).pipe(timeout(environment.defaultTimeout));
    }

    updateReProcessedToSample(labId: string, sampleid: string) {
        let url = this.PLATE_PREPARATION_API + 'updateReProcessedToSample/' + labId + "/" + sampleid;
        return this.httpClient.put<any>(url, sampleid).pipe(timeout(environment.defaultTimeout));
    }

    updateReceivedSamples(request: {}) {
        let url = this.SAMPLE_UPDATE_API + 'updateReceivedSamples';
        return this.httpClient.put<any>(url, request).pipe(timeout(environment.defaultTimeout));
    }


    updateStartProcessForMultiplePlates(multiPlateUpdate: MultiPlateUpdate) {
        let url = this.PLATE_PREPARATION_API + 'processStep/startProcess';
        return this.httpClient.put<BBResponseContainer>(url, multiPlateUpdate).pipe(map(result => result.data as string)).pipe(timeout(environment.defaultTimeout));
    }

    getRedoSampleCount(selectedLabId: string) {
        const url = `${this.PLATE_PREPARATION_API}sampleScan/count/redoSamples/${selectedLabId}`;
        return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as number)));
    }
    
    fetchStoragePlates(selectedLabId: string) {
        const url = `${this.PLATE_PREPARATION_API}fetch/storagePlates/${selectedLabId}`;
        return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as Plate[])));
      }
}